import * as CONST from './const'

const initState = {
  legalDocumentById: {},
  legalDocumentsList: [],
}

export function legalDocument(state = initState, action) {
  switch (action.type) {
    case CONST.GET_LEGAL_DOCUMENT_BY_ID_SUCCESS: {
      return {
        ...state,
        legalDocumentById: action.result.data.legalDocument,
      }
    }

    case CONST.GET_LEGAL_DOCUMENT_BY_ID: {
      return { ...state, legalDocumentById: {} }
    }

    case CONST.GET_LEGAL_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        legalDocumentsList: action.result.data.legalDocuments.edges.map(
          ({ node }) => node,
        ),
      }
    }

    case CONST.DELETE_LEGAL_DOCUMENT_BY_ID_SUCCESS: {
      const legalDocumentsList = Array.from(state.legalDocumentsList)
      const updatedIndex = state.legalDocumentsList.findIndex(
        doc => doc.id == action.payload.id,
      )
      const updatedDocument = {
        ...legalDocumentsList[updatedIndex],
        active: !action.result.data.deleteLegalDocument,
      }
      legalDocumentsList.splice(updatedIndex, 1, updatedDocument)

      return {
        ...state,
        legalDocumentsList,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/LegalDocument/reducer.js